import { fetchWithAuth } from './auth';

export interface InspectionRouteEstimate {
  id: string;
  org_id: string;
  inspection_id: string;
  calendar_event_id: string | null;
  assigned_user_id: string | null;
  origin_type: string;
  origin_address: string | null;
  destination_address: string | null;
  provider: string;
  travel_duration_seconds: number | null;
  distance_meters: number | null;
  target_arrival_time: string | null;
  leave_by_time: string | null;
  traffic_model: string | null;
  calculated_at: string;
  stale_after: string | null;
  status: string;
  error_message: string | null;
  raw_summary: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export async function getRouteEstimate(
  appraisalId: string,
  inspectionId: string,
): Promise<InspectionRouteEstimate | null> {
  const r = await fetchWithAuth(`/api/appraisals/${appraisalId}/inspections/${inspectionId}/route-estimate`);
  if (!r.ok) throw new Error(`getRouteEstimate failed: ${r.status}`);
  return (await r.json()) as InspectionRouteEstimate | null;
}

export async function recalculateRouteEstimate(
  appraisalId: string,
  inspectionId: string,
): Promise<InspectionRouteEstimate> {
  const r = await fetchWithAuth(`/api/appraisals/${appraisalId}/inspections/${inspectionId}/route-estimate/recalculate`, {
    method: 'POST',
  });
  if (!r.ok) throw new Error(`recalculateRouteEstimate failed: ${r.status}: ${(await r.text()).slice(0, 200)}`);
  return (await r.json()) as InspectionRouteEstimate;
}
